<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__customers}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.name" placeholder="客户姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input @change="mobileChange" v-model="dataForm.mobile" placeholder="手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.mobileMd5Value" placeholder="MD5" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.channelId" filterable clearable placeholder="请选择渠道">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-select v-model="dataForm.pageId" filterable clearable placeholder="请选择落地页">
            <el-option
                    v-for="item in pages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTimes"
            value-format="yyyy-MM-dd"
            align="right">
          </el-date-picker>
          <!-- <el-date-picker
                  v-model="dataForm.startDate"
                  type="date"
                  placeholder="录入开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.endDate"
                  type="date"
                  placeholder="录入结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker> -->
        </el-form-item>
        <!-- standardList -->
        <!-- <el-form-item>
          <el-select v-model="dataForm.standardCompanies" filterable  clearable placeholder="公司运营方式">
            <el-option
                    v-for="item in standardList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-select v-model="dataForm.companyId" filterable  clearable placeholder="所属公司">
            <el-option
                    v-for="item in cCompanys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <!-- <el-form-item>
          <el-select v-model="dataForm.type" filterable  clearable placeholder="回访结果">
            <el-option
                    v-for="item in callTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        
        <el-form-item>
          <el-select v-model="dataForm.isPush" filterable clearable placeholder="是否推送">
            <el-option
                    v-for="item in isPushs"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item >
              <el-select v-model="dataForm.isFixed" filterable  clearable placeholder="直投查询">
                  <el-option
                          v-for="item in isFixedList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item> -->
      <!-- <el-form-item >
              <el-select v-model="dataForm.operationName" filterable  clearable placeholder="运营机构查询">
                  <el-option
                          v-for="(item,index) in operationsList"
                          :key="index"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item> -->
      <el-form-item>
          <el-select v-model="dataForm.city" filterable clearable placeholder="请选择城市">
            <el-option
                    v-for="item in citys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
          <el-select v-model="dataForm.step" filterable clearable placeholder="请选择提交步骤">
            <el-option
                    v-for="item in submitList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>
    <!-- <el-form-item >
    <el-select v-model="dataForm.loanType" filterable clearable placeholder="请选择贷款标识">
        <el-option
                v-for="item in loanTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
    </el-select>
    </el-form-item> -->
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customers:export')" type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customers:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customers:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column  v-if="$hasPermission('sys:customers:username')" prop="name" label="客户姓名" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:applymoney')" prop="money" label="申请金额" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:moblie')" prop="mobile" label="手机号(脱敏)" header-align="center" align="center" width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:phone')" prop="leadsQq" label="手机号" header-align="center" align="center" width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column  prop="mobileMd5Value" label="MD5" header-align="center" align="center" :show-overflow-tooltip="true" width="300"></el-table-column>
       
        <el-table-column v-if="$hasPermission('sys:customers:city')" prop="city" label="城市" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="step" label="提交步骤" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.step == 0">立即申请</span>
              <span v-if="scope.row.step == 1">提交申请</span>
              <span v-if="scope.row.step == 2">激活额度</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:status')" prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <div>
              <el-tag  v-if="scope.row.status == 1">有效</el-tag>
              <el-tag  v-if="scope.row.status == 0" type="danger">无效</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pushLog" label="推送日志" header-align="center" align="center" >
        
          <template slot-scope="scope">
              <el-tooltip  placement="top" class="tooltip">
              <div slot="content" class="content" v-html="scope.row.pushLog ? scope.row.pushLog.replace(/\n/g,'<br/>') : scope.row.pushLog"></div>
              <p class="showOverTooltip">{{ scope.row.pushLog }}</p>
            </el-tooltip>
          </template>
         
        
        
        </el-table-column>

        <el-table-column v-if="$hasPermission('sys:customers:companyName')" prop="companyName" label="所属公司" header-align="center" align="center" width="150" :show-overflow-tooltip="true">
           <template slot-scope="scope">
            <div @click="allcompanyName($event,scope.row)" class="shou"> 
              <i class="shou-c" v-if="scope.row.myisshow !== 1" :class="scope.row.myisshow ?  'el-icon-loading' : 'el-icon-view' "></i>
              <span style=" margin-left: 10px;"  v-html="scope.row.companyName">
              </span>
            </div>
             
              <!-- <el-button style="margin-left: 10px;"  icon="el-icon-view" size="mini"></el-button> -->
           </template>
        </el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:whatpage')" prop="pageName" label="所属落地页" header-align="center" align="center" width="150" :show-overflow-tooltip="true" ></el-table-column>
         <el-table-column v-if="$hasPermission('sys:customers:url')"  prop="url" label="落地页url" header-align="center" align="center" width="433">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.url" placement="top">
              <p class="showOverTooltip">{{scope.row.url}}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        
        <el-table-column prop="buyPrice" label="买入价" header-align="center" align="center"></el-table-column>
       
        <el-table-column  prop="pushDate" label="推送时间" header-align="center" align="center" width="150" :show-overflow-tooltip="true" ></el-table-column>
        <el-table-column  prop="createDate" label="创建时间" header-align="center" align="center" width="150" :show-overflow-tooltip="true" ></el-table-column>

        <el-table-column v-if="$hasPermission('sys:customers:pushStatus')" prop="pushStatus" label="推送状态" header-align="center" align="center"  :show-overflow-tooltip="true" ></el-table-column>
        
       

        <el-table-column v-if="$hasPermission('sys:customers:ispush')" prop="isPush" label="是否推送" header-align="center" align="center" :show-overflow-tooltip="true">
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.isPush === 1" size="small">是</el-tag>
	            <el-tag v-if="scope.row.isPush === 0" type="danger" size="small">否</el-tag>
        	</template>
        </el-table-column>
       <el-table-column v-if="$hasPermission('sys:customers:content')" prop="pushMsg" label="推送内容" header-align="center" align="center" :show-overflow-tooltip="true" >
          <!-- <template slot-scope="scope">
              <el-button  v-if="scope.row.pushMsg !=='string' && scope.row.pushMsg !==''" type="text" style="text-decoration: underline;" @click="handleReturnMsg(scope.row.pushMsg)">推送内容</el-button>
          </template> -->
       </el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:pushDate')" prop="pushDate" label="推送时间" header-align="center" align="center" width="155" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="returnMsg" class-name="mycolumn" label="返回信息" width="433"  header-align="center" align="center" >
          <!-- <template slot-scope="scope">
            <el-tooltip :content="scope.row.returnMsg" placement="top">
              <p class="showOverTooltip">{{scope.row.returnMsg}}</p>
            </el-tooltip>
          </template> -->
        </el-table-column>
        <el-table-column  v-if="$hasPermission('sys:customers:ip')" prop="ip" label="数据来源" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>

       
     
        <el-table-column v-if="$hasPermission('sys:customers:address')" prop="address" label="详细地址" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:operating')" prop="operationName" label="运营机构" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:channel')" prop="channelName" label="投放渠道" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="shopName" label="原始渠道" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="remark2" label="是否迁移" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.remark2 == '当天同行数据'">已迁移到CRM</span>
          </template>
        </el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:isMarried')" prop="isMarried" label="婚姻状况" header-align="center" align="center">
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.isPush === 1" size="small">未婚</el-tag>
	            <el-tag v-if="scope.row.isPush === 2" size="small">已婚</el-tag>
        	</template>
        </el-table-column>
        
        <el-table-column v-if="$hasPermission('sys:customers:cardNo')" prop="cardNo" label="身份证号码" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
         <el-table-column v-if="$hasPermission('sys:customers:sex')" prop="sex" label="性别" header-align="center" align="center">
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.sex === 1" size="small">男</el-tag>
	            <el-tag v-if="scope.row.sex === 2" size="small">女</el-tag>
        	</template>
        </el-table-column>

        <el-table-column v-if="$hasPermission('sys:customers:age')" prop="age" label="年齢" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="education" label="教育程度" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:professional')" prop="professional" label="职业" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="employmentTime" label="就业时长" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="monthlyIncome" label="月收入" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payrollType" label="工资发放形式" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="useFor" label="贷款用途" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="loanLongTime" label="贷款期限" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="creditSituation" label="信用情况" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isCredit" label="信用卡" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:shebao')" prop="shebao" label="社保" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:gongjijin')" prop="gongjijin" label="公积金" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:car')" prop="car" label="车产" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:carType')" prop="carType" label="车况" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:carModel')" prop="carModel" label="车型" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:carLife')" prop="carLife" label="车辆年限" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="baodanIs" label="商业保险" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="zmScore" label="芝麻信用" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="leadsArea" label="IP所在地" header-align="center" align="center" width="150" :show-overflow-tooltip="true" ></el-table-column>
        <el-table-column prop="weili" label="微粒贷" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="businessLicense" label="企业主" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="businessLife" label="企业经营时长" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:house')" prop="house" label="房产" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:houseType')" prop="houseType" label="房屋类型" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:houseSize')" prop="houseSize" label="房屋面积" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:houseLife')"  prop="houseLife" label="房屋年限" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
       
        
        <el-table-column prop="shopAddress" label="门店地址" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="leadsEmail" label="邮箱" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="leadsQq" label="qq号" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="bundle" label="个性化字段信息" header-align="center" align="center" width="150" :show-overflow-tooltip="true">
          <!-- <template slot-scope="scope">
              <el-button v-if="scope.row.bundle !=='string' && scope.row.bundle !==''" type="text" style="text-decoration: underline;" @click="handleReturnMsg(scope.row.bundle)">bundle</el-button>
          </template> -->
        </el-table-column>
        <el-table-column prop="leadsWechat" label="微信号" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
       
        <el-table-column prop="telLocation" label="号码归属地" header-align="center" align="center" width="130" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:customers:remark')"  prop="remark" label="备注" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="accountId" label="账户ID" header-align="center" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="accountName" label="账户名称" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="adgroupId" label="广告组ID" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="adgroupName" label="广告组名称" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="adsId" label="推广计划ID" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="adsName" label="推广计划名称" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="creativeId" label="创意ID" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="creativeName" label="广告创意" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="creatorName" label="创建人" header-align="center" align="center" width="155" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column  v-if="$hasPermission('sys:customers:createtime')" prop="createDate" label="创建日期" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="updateName" label="更新人" header-align="center" align="center" width="155" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" width="155" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column> -->
        
        <el-table-column prop="mobileLeaseQuantity" label="租机台数" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:customers:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:customers:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
            <!-- <el-button v-if="$hasPermission('sys:customers:againPush')" type="text" size="small" @click="againPush(scope.row.id)">{{ $t('重推') }}</el-button> -->
            <!-- <el-button v-if="$hasPermission('sys:customers:apiPush')" type="text" size="small" @click="manualPush(scope.row.id)">{{ $t('手动推送') }}</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>

    <el-dialog
      title="返回信息"
      :visible.sync="dialogVisible"
      width="30%"
     >
      <span>{{returnedMessagesVal}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
   
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './customers0608-add-or-update'
import { getOperations } from '../../../api/list'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      dialogVisible:false,
      returnedMessagesVal:'',
      mixinViewModuleOptions: {
        getDataListURL: '/sys/customers0608/page',
        getDataListIsPage: true,
        exportURL: '/sys/customers0608/export',
        deleteURL: '/sys/customers0608',
        deleteIsBatch: true
      },
   

      standardList: [
        {
          value: 0,
          label: "非标准化",
        },
        {
          value: 1,
          label: "标准化",
        },
      ],
      dateValue: '',
      pickerOptions: {
          shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // end.setTime(start.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          },
            
          {
            text: '昨天',
            onClick(picker) {
              console.log(picker)
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '过去七天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log(week,'week')
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;
              
              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              console.log("2312", start, end);
              picker.$emit("pick", [start, end]);
            },

          },
       ]
        }, 
      citys:[],
      submitList:[
        {
          value: 0,
          label:'立即申请'
        },
        {
          value: 1,
          label:'提交申请'
        },
        {
          value: 2,
          label:'激活额度'
        }
      ],
      loanTypes:[],
      dataForm: {
        id: '',
        isFixed: '',
        type: '',
        standardCompanies: '',
      },
      operationsList:[],
      isFixedList:[
          {
            value: 0,
            label:'非直投'
          },
          {
            value: 1,
            label:'直投'
          }
        ],
      pages:[],
      companys:[],
      channels:[],
      callTypes:[
        // {
        //     'label':'未回访',
        //     'value':0,
        // },
        // {
        //     'label':'有效表单',
        //     'value':1,
        // }
      ],
      isPushs:[
        {
            'label':'未推送',
            'value':0,
        },
        {
            'label':'已推送',
            'value':1,
        }
      ],
    }
  },
  components: {
    AddOrUpdate
  },
async  created () {
    
    if (this.mixinViewModuleOptions.createdIsNeed) {
      // this.query()
      this.getPageOptions();
      this.getCompanysOptions();
      this.getchannelsOptions();
      this.getCallTypeOptions();
      this.getCityOptions();
      this.getLoanTypeOptions();
      this.operationsList = []
     let res = await getOperations()
     if(res.data.code == 0){
      this.operationsList = res.data.data.list.map(item => ({value:item.name,label:item.name}))
     }else{
      this.$message.error(res.data.msg)
     }
    
    }
  },
  computed: {
    cCompanys(){
      return  this.companys.filter(item => item.standard == this.dataForm.standardCompanies)
    }
  },
  methods: {
    mobileChange(){
      if(!this.dataForm.mobile) delete this.dataForm.mobile
    },
    allcompanyName(e,row){
    console.log(e)
    if(  row.myisshow === 1) return;
      

      const i = this.dataList.findIndex(item => item.id == row.id)
    
      this.$set(this.dataList,i,{...this.dataList[i],myisshow: true})
      this.$http
        .get(`/sys/customers0608/${row.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.$set(this.dataList,i,{...this.dataList[i],myisshow: 1,companyName:  this.companys.filter(item => item.value == res.data.companyId)[0].label})
        })
        .catch(() => {});
    },
    handleReturnMsg(returnMsg){
      this.dialogVisible = true;
      this.$nextTick(() =>{
        this.returnedMessagesVal = returnMsg
      })
    },
      //初始化下拉框中的选项
      async getCityOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.citys.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    //初始化落地页下拉框中的选项
    async getPageOptions() {
      this.$http.get(`/sys/landingpages/list`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pages=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.pages.push({label:element.name,value:element.id})
          })
        }
      }).catch(() => {})
    },
    async getCallTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=return-type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.callTypes=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.callTypes.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
       //初始化贷款标识下拉框中的选项
       async getLoanTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=loan_type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.loanTypes=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.loanTypes.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http.get(`/sys/companies/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.companys = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.companys.push({label: element.name, value: element.id,standard: element.standard})
          })
        }
      }).catch(() => {
      })
    },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.channels.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
    
    againPush(id){
    	this.$http.get(`/sys/customers/againPush/${id}`,id).then(({ data: res }) => {
	        if (res.code !== 0) {
	          return this.$message.error(res.msg)
	        }
	        this.query();
	   }).catch(() => {})
	           
    },
    manualPush(id){
      this.$http.get(`/sys/customers/apiPush/${id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success(res.msg)
        this.query();
      }).catch(() => {})
    },
    getTimes() {
        if (this.dateValue != null) {
          let startDate = new Date(this.dateValue[0])
          let year = startDate.getFullYear();
          let month = String(startDate.getMonth() + 1).padStart(2, '0');
          let day = String(startDate.getDate()).padStart(2, '0');

          let endDate = new Date(this.dateValue[1])
          let e_year = endDate.getFullYear();
          let e_month = String(endDate.getMonth() + 1).padStart(2, '0');
          let e_day = String(endDate.getDate()).padStart(2, '0');
          
          this.dataForm.startDate =  `${year}-${month}-${day} 00:00:00`
          this.dataForm.endDate = `${e_year}-${e_month}-${e_day} 23:59:59`
        }else{
          delete this.dataForm.startDate 
          delete this.dataForm.endDate
        }
      },
  }
}
</script>

<style scoped lang="scss">
.showOverTooltip{
  display:-webkit-box;
  text-overflow:ellipsis;
  overflow:hidden;
    /*这里是3行*/
  -webkit-line-clamp: 3;
  -webkit-box-orient:vertical;
}
.shou {
  cursor: pointer;
   display: flex;
  justify-content: center;
  align-items: center;
}
.shou-c{
  width: 12px;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
